"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var cardLayout_1 = __importDefault(require("../../../../../components/CardLayout/cardLayout"));
var i18next_1 = require("i18next");
var react_1 = require("react");
var modal_1 = __importDefault(require("../../../../../components/modals/modal"));
function SuperfanSection() {
    var _a = (0, react_1.useState)(false), showModel = _a[0], setShowModel = _a[1];
    var superFansContent = [
        {
            title: "<p>\n        <b>".concat((0, i18next_1.t)("starsSuperFansPublicPost"), "</b>\n        <br />\n        ").concat((0, i18next_1.t)("starsSuperFansPublicPostMessage"), "\n        <br />\n        <b><span>$</span></b>\n      </p>"),
            url: "#",
            image: "https://loop-markets.directus.app/assets/d07f200a-4f2e-41c5-bd83-2d7145343aff",
        },
        {
            title: "\n        <p>\n          <b>\n            ".concat((0, i18next_1.t)("starsSuperFansFanClub"), "\n          </b>\n          <br />\n            ").concat((0, i18next_1.t)("starsSuperFansFanClubMessage"), "\n          <br />\n          <b><span>$$</span></b>\n        </p>\n      "),
            url: "#",
            image: "https://loop-markets.directus.app/assets/d1878ce2-dc31-4cb0-a94b-3dec13a1f829",
        },
        {
            title: "\n        <p>\n          <b>\n            ".concat((0, i18next_1.t)("starsSuperFansFans"), "\n          </b>\n          <br />\n            ").concat((0, i18next_1.t)("starsSuperFansFansMessage"), "\n          <br />\n          <b><span>$$$</span></b>\n        </p>\n      "),
            url: "#",
            image: "https://loop-markets.directus.app/assets/05349431-c73d-4658-8a60-1199795c43dd",
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cardLayout_1.default, { headline: (0, i18next_1.t)("starsSuperFansTitle"), list: superFansContent, hasButton: true, buttonText: "See Revenue Projections", buttonLink: "/clubs", setShowModel: setShowModel, showModel: showModel, bgStyle: {
                    backgroundImage: "url(/superFansBg1.svg), url(/superFansBg2.svg)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "left 70%, right 100%",
                    backgroundSize: "40%",
                } }), (0, jsx_runtime_1.jsx)(modal_1.default, { content: "<img class=\"modalImage\" src=\"https://loop-markets.directus.app/assets/72bbe1b3-ec2d-4009-8ead-353798650d11\" />", showBtn: false, open: showModel, close: function () { return setShowModel(false); }, btnAction: function () { return setShowModel(false); } })] }));
}
exports.default = SuperfanSection;
